import { useState, useEffect } from 'react';
import { Bell, X } from 'lucide-react';
import { getNotificationPermission, requestNotificationPermission } from '../lib/onesignal';

export function PushNotificationPrompt() {
  const [showPrompt, setShowPrompt] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    checkPermissionStatus();
  }, []);

  async function checkPermissionStatus() {
    const permission = await getNotificationPermission();
    
    // Show prompt if permission is not yet decided
    if (permission === 'default') {
      // Wait a bit before showing the prompt (better UX)
      setTimeout(() => setShowPrompt(true), 3000);
    }
  }

  async function handleAllow() {
    setIsLoading(true);
    try {
      const granted = await requestNotificationPermission();
      if (granted) {
        setShowPrompt(false);
      }
    } catch (error) {
      console.error('Failed to request permission:', error);
    } finally {
      setIsLoading(false);
    }
  }

  function handleDismiss() {
    setShowPrompt(false);
    // Remember user dismissed (optional: store in localStorage)
    localStorage.setItem('push-notification-dismissed', 'true');
  }

  if (!showPrompt) return null;

  return (
    <div className="fixed bottom-4 right-4 z-50 max-w-sm">
      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-lg border border-gray-200 dark:border-gray-700 p-4">
        <div className="flex items-start gap-3">
          <div className="flex-shrink-0">
            <div className="w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
              <Bell className="w-5 h-5 text-primary" />
            </div>
          </div>
          
          <div className="flex-1 min-w-0">
            <h3 className="text-sm font-semibold text-gray-900 dark:text-white mb-1">
              ເປີດການແຈ້ງເຕືອນ
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-300 mb-3">
              ຮັບການແຈ້ງເຕືອນທັນທີເມື່ອມີຄຳຂໍສິນເຊື່ອໃໝ່ ຫຼື ການປ່ຽນແປງສະຖານະ
            </p>
            
            <div className="flex gap-2">
              <button
                onClick={handleAllow}
                disabled={isLoading}
                className="flex-1 px-3 py-2 bg-primary text-white text-sm font-medium rounded-md hover:bg-primary/90 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                {isLoading ? 'ກຳລັງດຳເນີນການ...' : 'ອະນຸຍາດ'}
              </button>
              <button
                onClick={handleDismiss}
                disabled={isLoading}
                className="px-3 py-2 bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-300 text-sm font-medium rounded-md hover:bg-gray-200 dark:hover:bg-gray-600 disabled:opacity-50 disabled:cursor-not-allowed transition-colors"
              >
                ພາຍຫຼັງ
              </button>
            </div>
          </div>
          
          <button
            onClick={handleDismiss}
            disabled={isLoading}
            className="flex-shrink-0 text-gray-400 hover:text-gray-600 dark:hover:text-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <X className="w-5 h-5" />
          </button>
        </div>
      </div>
    </div>
  );
}
